// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input.custom-checkbox {
  vertical-align: middle;
  border: 0.5px solid var(--secondary-color-2);
  background-color: white;
  appearance: none;
  border-radius: 5px;
  height: 15px;
  width: 15px;
  margin-right: 5px;
  margin-bottom: 0;
  border-radius: 4px;
  position: relative;
}
input.custom-checkbox:disabled {
  background-color: #F4F5F6;
  border-color: #F4F5F6;
}
input.custom-checkbox:disabled:checked {
  border: 2px solid #DEDEDE;
  background-color: white;
}
input.custom-checkbox:disabled:checked:before {
  background: #DEDEDE;
  border-color: white;
  background: #DEDEDE;
}
input.custom-checkbox:checked:before {
  content: "";
  position: absolute;
  height: 9px;
  width: 9px;
  border: none;
  background: var(--primary-color-1);
  top: 2px;
  left: 2px;
  transform: none;
  margin-left: 0;
  border-radius: 2px;
}
input.custom-checkbox:not(:disabled):hover {
  opacity: 0.75;
}
input.custom-checkbox:active:not(:disabled) {
  border-color: var(--secondary-color-2);
}
input.custom-checkbox:focus {
  outline: none;
}
input.custom-checkbox:checked {
  border-color: var(--primary-color-1);
  background-color: white;
}

input.custom-checkbox + label {
  font-weight: 400;
  font-size: 12px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomCheckbox/customCheckbox.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,4CAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AACJ;AACI;EACI,yBAAA;EACA,qBAAA;AACR;AAAQ;EACI,yBAAA;EACA,uBAAA;AAEZ;AAAQ;EACI,mBAAA;EACA,mBAAA;EACA,mBAAA;AAEZ;AACI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,kCAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AACR;AACI;EACI,aAAA;AACR;AACI;EACI,sCAAA;AACR;AACI;EACI,aAAA;AACR;AACI;EACI,oCAAA;EACA,uBAAA;AACR;;AAGA;EACI,gBAAA;EACA,eAAA;EACA,eAAA;AAAJ","sourcesContent":["input.custom-checkbox {\n    vertical-align: middle;\n    border: .5px solid var(--secondary-color-2);\n    background-color: white;\n    appearance: none;\n    border-radius: 5px;\n    height: 15px;\n    width: 15px;\n    margin-right: 5px;\n    margin-bottom: 0;\n    border-radius: 4px;\n    position: relative;\n\n    &:disabled {\n        background-color: #F4F5F6;\n        border-color: #F4F5F6;\n        &:checked {\n            border: 2px solid #DEDEDE;\n            background-color: white;\n        }\n        &:checked:before {\n            background: #DEDEDE;\n            border-color: white;\n            background: #DEDEDE;\n        }\n    }\n    &:checked:before {\n        content: \"\";\n        position: absolute;\n        height: 9px;\n        width: 9px;\n        border: none;\n        background: var(--primary-color-1);\n        top: 2px;\n        left: 2px;\n        transform: none;\n        margin-left: 0;\n        border-radius: 2px;\n    }\n    &:not(:disabled):hover {\n        opacity: .75;\n    }\n    &:active:not(:disabled) {\n        border-color: var(--secondary-color-2);\n    }\n    &:focus {\n        outline:none;\n    }\n    &:checked {\n        border-color: var(--primary-color-1);\n        background-color: white;\n    }\n}\n\ninput.custom-checkbox + label {\n    font-weight: 400;\n    font-size: 12px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
